import { getSchemeCodeList } from '@/api/equipment-operational/index';
export default {
  data() {
    return {
      taskTypes: [],
      selectTaskType: '',
    };
  },
  watch: {
    selectTaskType() {
      this.requestTaskList();
    },
  },
  methods: {
    getTypeByProjectId(id) {
      getSchemeCodeList({ ProjectIdStr: id }).then((res) => {
        this.taskTypes = res.Data_Obj;
      });
    },
  }
};
